import { useState, useEffect } from "react";

// External Libraries
import { TabView, TabPanel } from "primereact/tabview";
import { Button } from "primereact/button";

// Styling
import { themeClasses as T, C } from "sj-ui-toolkit/src/atlas/utils";
import S from "../_styles.module.scss";

// Sandbox context hook(s)
import { useInstructionDetails, useInteraction } from "../contexts/SandboxHooks";

// Sub-components
import Instructions from "./Instructions";
import Tasks from "./Tasks";

const SandboxText = () => {
  const [showFinishButton, setShowFinishButton] = useState(false);
  const { instructions, hasFinishButton } = useInstructionDetails();
  const { maxStepCompleted, reportAllStepsCompleted } = useInteraction();

  useEffect(() => {
    // Determine if the Finish Lesson button should be shown
    const shouldShowFinishButton =
      hasFinishButton &&
      maxStepCompleted !== null &&
      instructions.steps &&
      maxStepCompleted === instructions.steps.length - 1;

    setShowFinishButton(shouldShowFinishButton);
  }, [hasFinishButton, maxStepCompleted, instructions.steps]);

  const handleFinishClick = async () => {
    await reportAllStepsCompleted();
    // Additional logic for finishing the lesson can be added here
  };

  return (
    <>
      <div className={C(S.sandboxTextContainer)}>
        <TabView
          pt={{
            navContainer: { className: C("sticky top-0 z-2", T.bgElevation0) },
            nav: { className: "atlas-h5" },
            inkbar: { className: T.bgGray300 },
            panelContainer: { className: C(T.bgElevation0, "p-0") },
          }}
        >
          <TabPanel header="Instructions">
            <Instructions steps={instructions.steps} />
          </TabPanel>
          {instructions.tasks && instructions.tasks.length > 0 && (
            <TabPanel header="Tasks">
              <Tasks tasks={instructions.tasks} />
            </TabPanel>
          )}
        </TabView>
        {showFinishButton && (
          <div className={C("mt-4", S.finishButtonContainer)}>
            <Button onClick={handleFinishClick} className={C("btn btn-primary", S.finishButton)}>
              Finish Lesson
            </Button>
          </div>
        )}
      </div>
    </>
  );
};

export default SandboxText;
